var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stages-template',{attrs:{"data":{ all: _vm.data }},on:{"onClickStage":_vm.onClickStage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }